import React from 'react'
import'./AddMoney.scss'
import {withRouter} from "react-router-dom";
import {compose} from "redux";
import {connect} from "react-redux";
import {numberFormat} from "../../util";
import {assetUrl} from "../../serviceApi";
import plus_image from '../../assets/images/ad-money-icon1.png'

const wrong_image =  assetUrl+'images/wrong_image.svg'
const play_image =  assetUrl+'images/wallet_illustration_3.png'
const home_image =  assetUrl+'images/icon_bank.svg'
const gift =  assetUrl+'images/icon_winning_purple.svg'
const circle_image =  assetUrl+'images/icon_grants_purple.svg'
const ibar_image =  assetUrl+'images/icon_info.svg'
// const plus_image = assetUrl+'images/ad-money-icon1.png'
const down_arrow = assetUrl+'images/withdraw-icon1.png'

const CashDetail = (props) => {
    const {setActiveModal,wallet_data} = props
    // const totalWalletBalance = () => {
    //     let deposit = parseInt(wallet_data.availableDeposit);
    //     let earnings = parseInt(wallet_data.availableEarnings);
    //     let grant = parseInt(wallet_data.availableGrantMoney);
    //     return (deposit + earnings + grant).toFixed(2);
    // }
  return (
    <div className={"cashDetail-component px-2"}>
        <div className="wallet-cash-banner mb-3">
            <div className="wallet-cash-banner-wrong_text  ">
                <img src={wrong_image} alt="Girl in a jacket" className="wallet-cash-banner-wrong_icon" onClick={()=>setActiveModal("")}/>
            </div>
        </div>
        <div className={'d-flex justify-content-between flex-column'}>
            <div className={"wallet-cash-card-wrap"}>
                <div className="wallet-cash-amount container mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <p className="wallet-cash-amount-wallet-cash-Available_text my-1">AVAILABLE AMOUNT</p>
                            <p className="wallet-cash-amount-wallet-cash-Available_number mt-1 mb-0">
                            {/*    ₹ {*/}
                            {/*    Object.keys(wallet_data).length > 0 ?*/}
                            {/*        totalWalletBalance():0*/}
                            {/*}*/}
	                            {
	                            	numberFormat(wallet_data.balance)
	                            }
                                {/*<span*/}
                                {/*style={{fontWeight:300,opacity:.5}}>.00</span>*/}
                            </p>
                        </div>

                        <img src={play_image} alt="Girl in a jacket" className="wallet-cash-amount-play_images"/>
                    </div>
                </div>
                <hr/>
                <div className="wallet-cash-card  my-3">
                    <div className="wallet-cash-card-heading p-3">
                        <div className=" d-flex justify-content-between">
                            <div className="d-flex align-items-center">
                                <img src={home_image} alt="Girl in a jacket"
                                     className="wallet-cash-cardDetail-icon p-1"/>
                                <p className="wallet-cash-card-sub_text my-1 mx-1">Deposit Cash</p>
                            </div>
                            <p className="wallet-cash-card-sub_number my-1">
                                ₹ {wallet_data.availableDeposit?wallet_data.availableDeposit:0}
                            </p>
                        </div>
                        <p className="wallet-cash-card-text_paragraph my-2">You can use this money to buy shares at any time.</p>
                    </div>
                </div>
                <div className="wallet-cash-card  my-3">
                    <div className="wallet-cash-card-heading p-3">
                        <div className=" d-flex justify-content-between">
                            <div className="d-flex align-items-center">
                                <img src={gift} alt="Girl in a jacket" className="wallet-cash-cardDetail-icon p-1"/>
                                <p className="wallet-cash-card-sub_text my-1 mx-1">winning cash</p>
                            </div>
                            <p className="wallet-cash-card-sub_number my-1">
                                ₹ {wallet_data.availableEarnings?wallet_data.availableEarnings:0}
                            </p>
                        </div>
                        <p className="wallet-cash-card-text_paragraph my-2">Money you win when your shares increase in value.</p>
                    </div>
                </div>
                <div className="wallet-cash-card  my-3">
                    <div className="wallet-cash-card-heading p-3">
                        <div className=" d-flex justify-content-between">
                            <div className="d-flex align-items-center">
                                <img src={circle_image} alt="Girl in a jacket"
                                     className="wallet-cash-cardDetail-icon p-1"/>
                                <p className="wallet-cash-card-sub_text my-1 mx-1">Bonus</p>
                            </div>
                            <p className="wallet-cash-card-sub_number my-1">
                                ₹ {wallet_data.availableGrantMoney?wallet_data.availableGrantMoney:0}
                            </p>
                        </div>
                        <p className="wallet-cash-card-text_paragraph my-2">Money earned from referrals and participating in polls.</p>
                    </div>
                </div>
                {/*<div className="wallet-cash-policy my-3">*/}
                {/*    <div className="d-flex align-items-center">*/}
                {/*        <img src={ibar_image} alt="Girl in a jacket" className="wallet-cash-policy-ibar_icon"/>*/}
                {/*        <p className="wallet-cash-policy-details_text my-1 mx-1">For more Details <span*/}
                {/*            className="wallet-cash-policy-details_policy"  onClick={() => props.history.push("privacy-policy")}>Read our Policy</span></p>*/}
                {/*    </div>*/}
                {/*</div>*/}

            </div>
            <div className="wallet-cash-button">
                <div className="d-flex justify-content-between my-3">
                    <button className="wallet-cash-button_purple d-flex align-items-center justify-content-center px-1 py-2 mr-3" onClick={() => setActiveModal("add")}>
                        <p className={"btn-text"}>Add Money </p>

                        <img
                        src={plus_image}
                        alt="Girl in a jacket" className="wallet-cash-button_button_icon"/></button>
                    <button className="wallet-cash-button_white  d-flex align-items-center justify-content-center px-1 py-2 " onClick={() => {
                        setActiveModal("withdraw")
                    }}>
                        <p className={"btn-text"}>Withdraw</p>


                        <img
                        src={down_arrow} alt="Girl in a jacket"
                        className="wallet-cash-button_button_icon "/></button>
                </div>
            </div>
        </div>



    </div>
  )
}


const mapStateToProps = state => ({
    wallet_data: state.WalletReducer.wallet_data
});

export default compose(
    withRouter,
    connect(mapStateToProps)
)(CashDetail);
